import React from 'react';
import GroupChannelComponent from '@sendbird/uikit-react/GroupChannel';
import {
  MessageContentProps,
  MessageContent,
} from '@sendbird/uikit-react/ui/MessageContent';
import { FileMessage } from '@sendbird/chat/message';
import ProductMessage from './ProductMessage';
import WrappedMessageInput from './MessageInput.web';
import ChatImage from './ChatImage.web';

interface ChannelProps {
  channelUrl: string;
  onChatHeaderActionClick?: () => void;
  onBackClick?: () => void;
}

const Channel = ({
  channelUrl,
  onChatHeaderActionClick,
  onBackClick,
}: ChannelProps) => {
  if (!channelUrl) {
    return null;
  }

  return (
    <GroupChannelComponent
      channelUrl={channelUrl}
      onChatHeaderActionClick={onChatHeaderActionClick}
      onBackClick={onBackClick}
      renderMessageInput={() => <WrappedMessageInput />}
      renderMessageContent={(props: MessageContentProps) => {
        const { message } = props;

        if (message.customType === 'product') {
          return (
            <ProductMessage
              message={props.message}
              channel={props.channel ?? undefined}
              currentUserId={props.userId}
              onDeleteMessage={props.deleteMessage}
            />
          );
        }

        // Handle image messages with custom aspect ratio rendering.
        // Use MessageContent with renderMessageBody to preserve avatar, name, timestamp.
        if (
          message instanceof FileMessage &&
          message.type &&
          message.type.startsWith('image/')
        ) {
          return (
            <MessageContent
              {...props}
              renderMessageBody={() => <ChatImage message={message} embedded />}
            />
          );
        }

        return <MessageContent {...props} />;
      }}
    />
  );
};

export default Channel;
